import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const GradeDropdownWithCreate = ({ curriculumId, value, onChange }) => {
  const [grades, setGrades] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (curriculumId) fetchGrades();
    else setGrades([]);
  }, [curriculumId]);

  const fetchGrades = async () => {
    const res = await api.get(`/grades/${curriculumId}`);
    setGrades(res.data);
  };

  const handleCreate = async () => {
    if (!newName.trim() || !curriculumId) return;
    setLoading(true);
    const res = await api.post('/grades', { name: newName, curriculum: curriculumId });
    setNewName('');
    setShowModal(false);
    await fetchGrades();
    onChange(res.data._id);
    setLoading(false);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-semibold mb-1">Grade</label>
      <div className="flex gap-2 items-center">
        <select
          className="rounded px-3 py-2 bg-eduvibe-blue text-white focus:outline-none"
          value={value}
          onChange={e => onChange(e.target.value)}
          disabled={!curriculumId}
        >
          <option value="">{curriculumId ? 'Select grade' : 'Select curriculum first'}</option>
          {grades.map(g => (
            <option key={g._id} value={g._id}>{g.name}</option>
          ))}
        </select>
        <button
          className="bg-eduvibe-green text-eduvibe-dark px-2 py-1 rounded hover:bg-eduvibe-green-dark font-bold text-lg"
          type="button"
          onClick={() => setShowModal(true)}
          disabled={!curriculumId}
          title="Add grade"
        >+
        </button>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-eduvibe-blue p-6 rounded-lg min-w-[300px]">
            <h2 className="text-lg font-bold mb-2 text-white">Add Grade</h2>
            <input
              className="w-full px-3 py-2 rounded mb-3 bg-eduvibe-dark text-white"
              placeholder="Grade name"
              value={newName}
              onChange={e => setNewName(e.target.value)}
              autoFocus
              disabled={loading}
            />
            <div className="flex gap-2 justify-end">
              <button onClick={() => setShowModal(false)} className="px-3 py-1 rounded bg-gray-600 text-white">Cancel</button>
              <button onClick={handleCreate} disabled={loading} className="px-3 py-1 rounded bg-eduvibe-green text-eduvibe-dark font-semibold hover:bg-eduvibe-green-dark">Create</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GradeDropdownWithCreate;
